import { SET_AVAILABLE_OFFSET_SEARCH_PRODUCT, SET_DATA_PRODUCT_FOR_EDIT, SET_FILTER_TEXT_SEARCH_PRODUCT, SET_FILTER_TYPE_CATEGORY, SET_MESSAGE_PRODUCT_STATE, SET_MESSAGE_SAVE_STATE_PRODUCT, SET_ORIGIN_REQUEST_LIST } from 'orden_express/products/productsActions.js';
import { REQUEST_RESET_STATE_PRODUCTS, RESPONSE_GET_ALL_PRODUCTS, RESPONSE_GET_MEASURE_UNIT, RESPONSE_GET_PRODUCTS_FILTER, RESPONSE_GET_PRODUCT_CATEGORY, RESPONSE_SAVE_PRODUCT } from 'orden_express/products/productsEpic.js';


const initialState = {
   dataProductForEdit: {},
   responseSaveProduct: {},
   responseGetProductCategory: [],
   responseGetMeasureUnit: [],
   responseGetAllProducts: [],
   availableOffsetSearchProduct: 0,
   filterTypeCategory: { value: '%', label: 'Todos' },
   filterTextSearchProduct: '',
   messageProductState: 0,
   originRequestList: [],
   messageSaveStateProduct: 0,
};

const productsReducer = (state = initialState, action) => {
   switch (action.type) {

      case REQUEST_RESET_STATE_PRODUCTS:
         return {
            ...state,
            dataProductForEdit: {},
            responseSaveProduct: {},
            responseGetProductCategory: [],
            responseGetMeasureUnit: [],
            responseGetAllProducts: [],
            availableOffsetSearchProduct: 0,
            filterTypeCategory: { value: '%', label: 'Todos' },
            filterTextSearchProduct: '',
            messageProductState: 0,
            originRequestList: [],
            messageSaveStateProduct: 0,
         };

      case SET_MESSAGE_PRODUCT_STATE:
         return {
            ...state,
            messageProductState: action.messageProductState
         };

      case SET_ORIGIN_REQUEST_LIST:
         return {
            ...state,
            originRequestList: action.originRequestList
         };

      case SET_AVAILABLE_OFFSET_SEARCH_PRODUCT:
         return {
            ...state,
            availableOffsetSearchProduct: action.availableOffsetSearchProduct
         };

      case SET_FILTER_TYPE_CATEGORY:
         return {
            ...state,
            filterTypeCategory: action.filterTypeCategory
         };

      case SET_FILTER_TEXT_SEARCH_PRODUCT:
         return {
            ...state,
            filterTextSearchProduct: action.filterTextSearchProduct
         };

      case SET_DATA_PRODUCT_FOR_EDIT:
         return {
            ...state,
            dataProductForEdit: action.dataProductForEdit
         };

      case RESPONSE_SAVE_PRODUCT:
         if (action.responseSaveProduct.errorState === true) {
            return {
               ...state,
               responseSaveProduct: action.responseSaveProduct,
               messageSaveStateProduct: 3
            };
         } else {
            return {
               ...state,
               responseSaveProduct: action.responseSaveProduct,
               messageSaveStateProduct: 2
            };
         }

      case RESPONSE_GET_PRODUCT_CATEGORY:
         return {
            ...state,
            responseGetProductCategory: action.responseGetProductCategory
         };

      case RESPONSE_GET_MEASURE_UNIT:
         return {
            ...state,
            responseGetMeasureUnit: action.responseGetMeasureUnit
         };

      case RESPONSE_GET_PRODUCTS_FILTER:
         if (action.responseGetProductsFilter.errorState === true) {
            return {
               ...state,
               responseGetAllProducts: action.responseGetProductsFilter,
               messageProductState: 3,
            };
         } else {
            return {
               ...state,
               responseGetAllProducts: action.responseGetProductsFilter,
               availableOffsetSearchProduct: action.responseGetProductsFilter.filterNavegation.offset,
               messageProductState: 2,
            };

         }

      case RESPONSE_GET_ALL_PRODUCTS:
         return {
            ...state,
            responseGetAllProducts: action.responseGetAllProducts
         };

      case SET_MESSAGE_SAVE_STATE_PRODUCT:
         return {
            ...state,
            messageSaveStateProduct: action.messageSaveStateProduct
         };

      default:
         return state;
   }
}
export default productsReducer;